module.exports = __webpack_public_path__ + "static/logo.653b6ab6.png";